import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
import {
  Button,
  ReferenceInput,
  required,
  SelectInput,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "react-admin";
import { activityRequests } from "api/activityApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ManageStudentsLevelDialog = ({ foreignLanguageId }) => {
  const { data, selectedIds } = useListContext();
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll(activityRequests.entryTestStudentsByForeignLanguage(foreignLanguageId));

  const handleSubmit = async values => {
    const payload = {
      students: selectedIds.map(id => ({
        studentEducationId: data[id].studentEducationId,
        level: values.level,
      })),
    };
    await dataProvider.customRequest(activityRequests.manageEntryTestStudentAssignments(), payload, "PATCH");
    notify("Студентите са разпределени успешно", { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <FormModal
      titleContent="Разпредели студенти в ниво"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          size="medium"
          color="primary"
          startIcon={<SafetyDividerIcon />}
          label="Разпредели студенти"
        />
      }
    >
      <ReferenceInput
        reference={activityRequests.getActivityForeignLanguageLevelsByLanguageSelect(foreignLanguageId)}
        source="level"
      >
        <SelectInput
          label="Ниво на език"
          optionText="name"
          validate={required()}
        />
      </ReferenceInput>
    </FormModal>
  );
};

export default ManageStudentsLevelDialog;
